import type React from "react";
import { Check } from "lucide-react";
import { pl } from "../i18n/pl";
import type { Feedback, Problem } from "../types";
import styles from "./Flashcard.module.css";

type FlashcardProps = {
  answer: string;
  feedback: Feedback;
  inputRef: React.RefObject<HTMLInputElement | null>;
  problem: Problem;
  onAnswerChange: (answer: string) => void;
  onSubmit: (event: React.FormEvent) => void;
};

export function Flashcard({
  answer,
  feedback,
  inputRef,
  problem,
  onAnswerChange,
  onSubmit,
}: FlashcardProps) {
  return (
    <form
      className={`${styles.flashcard} ${styles[feedback]}`}
      onSubmit={onSubmit}
    >
      <div className={styles.problemLine} aria-live="polite">
        <span className={styles.factor}>{problem.a}</span>
        <span className={styles.operator} aria-hidden="true">
          x
        </span>
        <span className={styles.factor}>{problem.b}</span>
        <span className={styles.equals} aria-hidden="true">
          =
        </span>
      </div>
      <input
        className={styles.answerInput}
        ref={inputRef}
        id="answer"
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="off"
        value={answer}
        onChange={(event) => onAnswerChange(event.target.value)}
        placeholder={pl.answerPlaceholder}
        aria-label={pl.answerLabel}
        aria-describedby="answer-feedback"
      />
      <p id="answer-feedback" className={styles.feedbackText}>
        <FeedbackMessage feedback={feedback} />
      </p>
      <div className={styles.actions}>
        <button className={styles.primaryButton} type="submit">
          {pl.check}
        </button>
      </div>
    </form>
  );
}

function FeedbackMessage({ feedback }: { feedback: Feedback }) {
  return (
    <>
      <Check size={17} /> {pl.feedback}
    </>
  );
}
